<template>
  <div
    v-if="!$route.meta.noSearch"
    class="f-b-c header-search-view el-no-border fb-14"
  >
    <el-select
      v-model="searchType"
      placeholder="请选择"
      class="primary-selected bgf5 fb-14"
    >
      <el-option
        v-for="item in options"
        :key="item[optionConfig.CODE]"
        :label="item[optionConfig.LABEL]"
        :value="item[optionConfig.CODE]"
      />
    </el-select>
    <el-input
      v-model="searchValue"
      class="input"
      placeholder="请输入关键词搜索"
      clearable
      @keyup.enter.native="search"
    />
    <el-button type="primary" class="fill-h my-search-btn" @click="search">
      搜索
    </el-button>
  </div>
</template>

<script>
import {
  getConstantDic,
  SEARCH_INPUT_OPTIONS_TYPES,
  SELECT_OPTION_CONFIG,
} from "@/utils/constant";
import { mapGetters } from "vuex";

export default {
  name: "HeadSearch",
  components: {},
  props: {},
  data() {
    return {
      searchType: "",
      searchValue: "",
      options: getConstantDic(SEARCH_INPUT_OPTIONS_TYPES),
      optionConfig: SELECT_OPTION_CONFIG,
    };
  },

  computed: {
    ...mapGetters(["site", "allMenusList"]),
    searchPath() {
      const searchItem =
        this.allMenusList.find((m) => m.code === this.searchType) || {};
      return searchItem.path;
    },
  },
  watch: {
    searchType(v) {
      sessionStorage.setItem("searchType", v);
    },
  },

  created() {},

  mounted() {
    this.searchValue = this.$route.query.title || "";
    this.searchType =
      sessionStorage.getItem("searchType") ||
      SEARCH_INPUT_OPTIONS_TYPES.BIDDING_NOTICE[SELECT_OPTION_CONFIG.CODE];
  },

  methods: {
    search() {
      const keyword = this.searchValue;
      this.searchValue = "";
      const route = this.$router.resolve({
        path: this.searchPath,
        query: {
          title: keyword,
        },
      });
      window.open(route.href, "_self");
    },
  },
};
</script>

<style scoped lang="scss">
.header-search-view {
  width: 460px;
  height: 40px;

  :deep(.input) .el-input__inner {
    border-left: none;
    border-right: none;
  }
  ::v-deep {
    .el-input__inner {
      border: 2px solid #ddd;
      height: 40px;
      border-radius: 0;
      font-weight: 400;
    }
  }
}
.my-search-btn {
  width: 80px;
  font-size: 14px;
  padding: 0;
  flex-shrink: 0;
  border-radius: 0;
}
</style>
